/**
 * Global namespace for most components active class.
 */
const activeClass = "active";
export default activeClass;
